"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountProductType = void 0;
var AccountProductType;
(function (AccountProductType) {
    AccountProductType["MOAP"] = "MOAP";
    AccountProductType["AVEN_CASH"] = "AVEN_CASH";
})(AccountProductType || (exports.AccountProductType = AccountProductType = {}));
